// extracted by mini-css-extract-plugin
module.exports = {"button":"PrimaryButton_button__Z9bOs","ripple":"PrimaryButton_ripple__QMs1p"};